import { useEffect, useState } from "react"
import { ClientApi } from "../../../services/clientApi"
import { NuiMessages } from "../../../utils/ClientEvents"
import "./Countdown.css"

export const Countdown = () => {

    const [number, setNumber] = useState(3)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        ClientApi.on(NuiMessages.COUNTDOWN, () => {
            setNumber(3)
            setIsVisible(true)
        })
    }, [])

    useEffect(() => {
        if (!isVisible) return

        const audio = new Audio("/sounds/3_2_1.wav")
        audio.play()

        const timer = setInterval(() => {
            setNumber((prev) => {
                if (prev <= 1) {
                    clearInterval(timer)
                    setIsVisible(false)
                    return prev
                }
                return prev - 1
            })
        }, 1000)

        return () => clearInterval(timer)
    }, [isVisible])

    if (!isVisible) return null

    return (
        <div className="countdown-container">
            <div className={number === 1 ? 'number-container active' : 'number-container'}>
                <h1 className={number === 1 ? 'number active' : 'number'}>
                    {number}
                </h1>
            </div>
        </div>
    )
}
